import { Component, OnInit,ViewChild } from '@angular/core';
import { RequestService } from '../../../../services/request.service';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http'; 
import { Router, ActivatedRoute } from "@angular/router";
import { DataTableDirective} from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { globalType } from '../../dashboard/dashboard.component';

@Component({
  selector: 'app-toilet-report',
  templateUrl: './toilet-report.component.html',
  styleUrls: ['./toilet-report.component.scss']
})
export class ToiletReportComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
	dtElement: DataTableDirective;
	dtOptions: any = {};
	// dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(
    private request : RequestService,
    private http: HttpClient,
    private router: Router,
    private datePipe:DatePipe
  ) { }

  roleId=0;
  ngOnInit(): void {
    this.roleId = Number(localStorage.getItem('roleId'));
    if(globalType!=null && globalType!=""){
      this.ViewToilets(globalType);
    }else{
          this.ViewToilets("all");
    }
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      dom: 'Bfrtip',
        buttons: [
        {
          extend: 'csv',
          text:      '<i class="fa fa-file-text-o"></i>',
          titleAttr: 'Download as CSV',
          title: 'Device Master' 
        },
        {
          extend: 'excel',
          text:      '<i class="fa fa-file-excel-o"></i>',
          titleAttr: 'Download as Excel',
          title: 'Device Master' 
        },
        {
          extend: 'pdf',
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: 'Download as Pdf',
          title: 'Device Master' 
        }
      ]
    };
  }

  ShowReport(){
    let dateTime = this.datePipe.transform($("#dateTime").val(),"yyyy-MM-dd");
    let fromDate = dateTime+" 00:00:00";
    let toDate = dateTime+" 23:59:59";
     console.log(fromDate+" :: "+toDate);
  }

  toiletRowdata:any;
  toiletDetails=[];
  isLoading=false;
  async ViewToilets(type:any){
    try {
      this.isLoading=true;
      // alert("here");
      const device = {
        'currentStatus': type,
      };
      this.dtTrigger=new Subject<any>();
      const data: any = await this.request.post('/master/view_toilet_status_report',device);
      this.toiletDetails=[];
      //alert(data);
      this.dtTrigger.next();
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            dataObj[objKey1].device_assignment_date = this.normalizeTimestamp(Number(dataObj[objKey1].device_assignment_date));
            this.toiletDetails.push(dataObj[objKey1]);
          } 
        }				
      }
      this.toiletRowdata = this.toiletDetails;
      this.isLoading=false;
      // console.log(this.toiletRowdata);
    } catch (error) {}
  }

  async UpdateLiveDeviceStatus(device_id:any){
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Clean it!'
      });
      if (confirm.value) {
      const device = {
        'deviceId': device_id
      };
      const allow: any = await this.request.post('/dashboard/update_and_clean_live_device_status/',device);
      if (allow) {
      // Successfully Deleted
      Swal.fire(
      'Updated!',
      'Device Information has been updated.',
      'success'
      );
      // Reload DataTable
      // window.location.reload();
      this.ViewToilets(globalType);
      } else {
      Swal.fire(
        'Error!'
      );
      }
    }
  }

  normalizeTimestamp(timestamp: number): number {
    const length = timestamp.toString().length;

    if (length === 10) {
      // Convert seconds → milliseconds
      return timestamp * 1000;
    } else if (length === 13) {
      // Already in milliseconds
      return timestamp;
    } else {
      throw new Error("Invalid timestamp format");
    }
  }

} 
 